import * as React from 'react'
import { LogPointsHeader, Props as HeaderProps } from './LogPointsHeader/LogPointsHeader'
import { ResourceType } from '@mulesoft/monitoring-center-components/lib/models/resource'
import { transformToEnvironmentSelectorProps } from '../../../common/environment/model'
import { transformToResourceSelectorProps } from '../../../common/resource/model'
import { transformToVersionSelectorProps } from '../../../common/version/model'
import { ResourceSelectorState } from '../../../common/resource/reducer'
import { VersionSelectorState } from '../../../common/version/reducer'
import { EnvironmentSelectorState } from '../../../common/environment/reducer'
import { LogPointsType } from './model'
import { LOG_POINTS_BODIES, LogPointsBody } from '../LogPointsBody/LogPointsBody'
import Spinner from '@mulesoft/anypoint-components/lib/Spinner'
import './LogPointsPage.css'

export type ExternalValueProps = {
  type: LogPointsType
  environmentId: string
  resourceId: string
  versionId?: string
  targetId?: string
}

export type ValueProps = ExternalValueProps & {
  organizationId: string
  environmentSelector: EnvironmentSelectorState
  resourceSelector: ResourceSelectorState
  versionSelector: VersionSelectorState
}

export type EventProps = {
  load: (props: ExternalValueProps) => void
  onView: (props: ExternalValueProps) => void
  environmentSelected: (environmentId: string) => void
  resourceSelected: (resourceId: string, resourceType: ResourceType) => void
  versionSelected: (versionId: string) => void
  fetchConnectors: () => void
}

export type Props = ValueProps & EventProps

export class LogPointsPage extends React.Component<Props> {

  constructor(props: Props) {
    super(props)

    this.getHeaderProps = this.getHeaderProps.bind(this)
    this.onHeaderView = this.onHeaderView.bind(this)

    props.fetchConnectors()
  }

  getLogPointsBody() {
    const {organizationId, environmentId, resourceId, versionId, targetId, type} = this.props

    const commonProps = {organizationId, environmentId, resourceId, isSaveButtonDisabled: false}

    if (type === LogPointsType.API) {
      return LOG_POINTS_BODIES.api({...commonProps, versionId: versionId || ''})
    } else {
      return LOG_POINTS_BODIES.application({...commonProps, targetId: targetId})
    }
  }

  getHeaderProps(): HeaderProps {
    const {environmentSelector, resourceSelector, versionSelector} = this.props

    return {
      className: 'log-points-page-selector-container',
      environmentSelector: transformToEnvironmentSelectorProps(environmentSelector, 25, 'log-points-environment-selector'),
      resourceSelector: transformToResourceSelectorProps(resourceSelector, 40, 'log-points-resource-selector'),
      versionSelector: transformToVersionSelectorProps(versionSelector, 35, 'log-points-version-selector'),
      environmentSelected: this.props.environmentSelected,
      resourceSelected: this.props.resourceSelected,
      versionSelected: this.props.versionSelected,
      onView: this.onHeaderView
    }
  }

  onHeaderView(environmentId: string, resourceId: string, versionId?: string) {
    this.props.onView({environmentId, resourceId, versionId, type: versionId ? LogPointsType.API : LogPointsType.APPLICATION})
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<{}>, prevContext: any): void {
    const {environmentId, resourceId, targetId, versionId} = this.props
    const newEnvironmentId = prevProps.environmentId !== environmentId
    const newResourceId = prevProps.resourceId !== resourceId
    const newTargetId = prevProps.targetId !== targetId
    const newVersionId = prevProps.versionId !== versionId

    if (newEnvironmentId || newResourceId || newTargetId || newVersionId) {
      this.props.load(this.props)
    }
  }

  componentWillMount() {
    this.props.load(this.props)
  }

  render() {
    const logPointsBody = this.getLogPointsBody();
    const headerProps = this.getHeaderProps()

    return (
      <div className="log-points-page" data-test-id="log-points-page">
        <LogPointsHeader {...headerProps}/>
        {logPointsBody && <LogPointsBody logPointsBody={logPointsBody}/>}
        {!logPointsBody &&
          <div className="log-points-page-loading" data-test-id="log-points-page-loading">
            <Spinner/>
          </div>
        }
      </div>
    )
  }
}
